import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['title']
  static values = { observeSelector: String }

  declare titleTarget: HTMLElement
  declare hasTitleTarget: boolean
  declare observeSelectorValue: string

  observer: IntersectionObserver | null = null

  connect() {
    const observeElement = document.querySelector(this.observeSelectorValue)
    if (!observeElement || !this.hasTitleTarget) return

    const title = this.titleTarget

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Sentinel sichtbar = Leiste klebt noch nicht, Titel ausblenden
        title.classList.toggle('d-none', entry.isIntersecting)
      })
    }, { threshold: 0 })

    this.observer.observe(observeElement)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
